import { __assign } from "tslib";
import React, { useContext } from 'react';
import { CommentContext } from '../../CommentContext';
/**
 * We need these data attributes on a certain level of our comment views, so we have this component to make it easy
 * to include it in multiple places.
 */
var CommentDataAttrDiv = function (props) {
    var comment = useContext(CommentContext).comment;
    return (React.createElement("div", __assign({ "data-commentid": comment.commentId, "data-typeid": comment.typeId, "data-itemid": comment.itemId }, props)));
};
CommentDataAttrDiv.displayName = 'CommentDataAttrDiv';
export default CommentDataAttrDiv;
//# sourceMappingURL=CommentDataAttrDiv.js.map